import React from 'react';
import { useParams } from 'react-router-dom';
import AdminSpiritualProfile from '../components/Admin/AdminSpiritualProfile';

export default function AdminSpiritualProfilePage() {
  const { id } = useParams();
  return <AdminSpiritualProfile userId={id ?? ''} />;
}
